import { LotteryExecStatus } from '../types';

export const ExecLotteryResultText = {
  [LotteryExecStatus.limit]: '已達領取上限',
  [LotteryExecStatus.used]: '抽獎碼已被使用',
  [LotteryExecStatus.soldOut]: '獎賞已派完',
  [LotteryExecStatus.end]: '活動已結束',
  [LotteryExecStatus.wrongCdkey]: '抽獎碼錯誤',
};
